<template>
  <div class="menu-box">
    <el-menu
      :default-active="active_index"
      mode="horizontal"
      @select="menuSelect"
      :backgroundColor="background_color"
      :textColor="text_color"
      :activeTextColor="active_text_color"
      :collapseTransition="false"
    >
      <el-menu-item v-for="(item, index) in list" :key="index" :index="item.value">{{ item.name }}</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      stpe: Array,
      required: true,
    },
    active_index: {
      type: String,
      default: '1',
    },
  },
  data() {
    return {
      background_color: 'rgba(0, 52, 84, 1)', // 菜单背景色
      text_color: '#FFFFFF', // 菜单文字颜色
      active_text_color: '#242424', // 当前激活菜单的文字颜色
    };
  },
  methods: {
    menuSelect(key, keyPath) {
      let item = this.list[parseFloat(key) - 1];
      this.$emit('handleChange', key, keyPath, item);
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/styles/variables.less';
.menu-box {
  background-color: @theme-dark;
  padding: 0 13%;
  .el-menu--horizontal > .el-menu-item {
    font-size: 18px;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    background-color: #fff !important;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border: none;
    border-top: 2px solid @theme-color;
  }
  .el-menu.el-menu--horizontal {
    border-bottom: none;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/menu/index.vue